import { Component, OnInit, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import { Unidade } from 'src/app/models/unidade';
import { Auth } from 'src/app/models/auth';
import { StatusCadastro } from 'src/app/shared/enums/status-cadastro.enum';
import { OverlayRef, Overlay } from '@angular/cdk/overlay';
import { Subscription, fromEvent } from 'rxjs';
import { UnidadeService } from 'src/app/services/unidade.service';
import { AuthenticationService } from 'src/app/services/authentication.service';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router, ActivatedRoute } from '@angular/router';
import { TemplatePortal } from '@angular/cdk/portal';
import { filter, take } from 'rxjs/operators';
import * as removeAccents from 'remove-accents';
import { NewAlertService } from 'src/app/shared/components/new-alert/new-alert.service';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-unidade-list',
  templateUrl: './unidade-list.component.html'
})
export class UnidadeListComponent implements OnInit {

  //#region Propriedades
  public currentUser: Auth;
  public unidades: Unidade[];
  public unidadesList: Unidade[];
  public Status = StatusCadastro;
  //#endregion

  //#region Filtro
  public filtroCodigo: string;
  public filtroNome: string;
  sortOrder: boolean;

  public codeCtrl: FormControl = new FormControl();
  public nameCtrl: FormControl = new FormControl();
  //#endregion

  //#region Menu de Contexto
  overlayRef: OverlayRef | null;
  subscription: Subscription;
  @ViewChild('contextMenu', { static: true }) contextMenu: TemplateRef<any>;
  //#endregion

  //#region Paginação
  currentPage = 1;
  showItem = '10';
  //#endregion

  //#region Modal Delete
  public unidadeToDelete: Unidade;
  public deleteCount: number;
  public selectAll: boolean;
  //#endregion

  constructor(
    private unidadeService: UnidadeService,
    private authenticationService: AuthenticationService,
    private alertService: NewAlertService,
    private modalService: NgbModal,
    private router: Router,
    private route: ActivatedRoute,
    public overlay: Overlay,
    public viewContainerRef: ViewContainerRef) { }

  ngOnInit() {
    this.currentUser = this.authenticationService.currentUserValue;
    this.loadList();
  }

  loadList() {
    this.unidadeService.getAll(this.currentUser.token.assignorGuid).subscribe(
      response => {
        this.unidades = response.result;
        this.unidadesList = response.result;
      },
      error => {
        this.alertService.error('Ocorreu um erro ao consultar unidades. Por favor tente novamente mais tarde');
      }
    );
  }

  create() {
    this.router.navigate(['create'], { relativeTo: this.route.parent });
  }

  edit(unidade: Unidade) {
    this.router.navigate([`edit/${unidade.unidadeId}`], { relativeTo: this.route.parent });
  }

  //#region Filtros

  showFilter(content: any) {
    this.modalService.open(content, { centered: true, size: 'lg' });
  }

  realodList() {
    let tempList = this.unidades;
    if (this.filtroCodigo) {
      tempList = tempList.filter(s => removeAccents(s.codigo).toLowerCase().includes(removeAccents(this.filtroCodigo).toLowerCase()));
    }

    if (this.filtroNome) {
      tempList = tempList.filter(s => removeAccents(s.nome).toLowerCase().includes(removeAccents(this.filtroNome).toLowerCase()));
    }

    this.unidadesList = tempList;
  }

  orderBy(collumnName: string, sortOrder: boolean) {
    this.unidadesList.sort(
      (a, b) => {
        const dftl = sortOrder ? Number.MAX_VALUE : -Number.MAX_VALUE;
        const aVal = (a[collumnName] === null ? dftl : a[collumnName]).toString();
        const bVal = (b[collumnName] === null ? dftl : b[collumnName]).toString();
        let result = aVal.localeCompare(bVal, undefined, { numeric: true });
        if (sortOrder) {
          result = bVal.localeCompare(aVal, undefined, { numeric: true });
        }
        return result;
      }
    );
  }

  applyFilter() {
    this.filtroCodigo = this.codeCtrl.value;
    this.filtroNome = this.nameCtrl.value;
    this.realodList();
  }

  searchFilter(word: string) {
    if (!word) {
      this.unidadesList = this.unidades;
    } else {
      word = removeAccents(word).toLocaleLowerCase();
      this.unidadesList = this.unidades
        .filter(s => removeAccents(s.codigo).toLocaleLowerCase().includes(word) || removeAccents(s.nome).toLocaleLowerCase().includes(word));
    }
  }

  //#endregion

  //#region Delete

  showDelete(content: any, unidade: Unidade) {
    this.unidadeToDelete = unidade;
    this.modalService.open(content, { centered: true, size: 'lg' });
  }

  delete(unidade: Unidade) {
    this.unidadeService.delete(unidade.unidadeId, this.currentUser.token.assignorGuid, this.currentUser.token.userReferenceId).subscribe(
      response => {
        this.alertService.success(response.message);
        this.loadList();
        this.realodList();
      },
      error => {
        this.alertService.error('Ocorreu um erro ao excluir a unidade');
      }
    );
  }

  updateDeleteCount() {
    this.deleteCount = this.unidadesList.filter(x => x.toDelete).length;
  }

  selectAllToDelete(value: boolean) {
    this.unidadesList.forEach(obj => {
      obj.toDelete = value;
    });
    this.updateDeleteCount();
  }

  showDeleteAll(content: any) {
    this.updateDeleteCount();
    this.modalService.open(content, { centered: true, size: 'lg' });
  }

  deleteAllSelected() {
    this.unidadesList.forEach(obj => {
      if (obj.toDelete) {
        this.delete(obj);
      }
    });
    this.updateDeleteCount();
  }

  //#endregion
}
